import { I3pService } from '@nuxtDatakodeUtils/services/i3p.service'
import type { I3pServiceInterface } from '@nuxtDatakodeUtils/services/i3p.service.interface'
import { Intention } from '~/models/Intention'

type IntentionData = PildomModules.Voirie.Data.IntentionData

export class IntentionI3pService extends I3pService<IntentionData> implements I3pServiceInterface {
    readonly type = 'intention'
    getModel(): Intention {
        return new Intention()
    }

    getLayerName(): string {
        return 'Intentions'
    }

    getGeometrySubtype(): string {
        return 'MultiLineString'
    }
}
